import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FileDocumentPickerInterface {
  appplyActionStatus: boolean;
  fileDocumentDetail: FileStringDetail | null;
}

interface FileStringDetail {
  fromAction: string;
  fileName: string;
  fileString: string | null;
}

const initialState: FileDocumentPickerInterface = {
  appplyActionStatus: false,
  fileDocumentDetail: null,
};

const FileDocumentPicker = createSlice({
  name: "filedocumentpicker",
  initialState,
  reducers: {
    appplyActionDocument: (state, action: PayloadAction<boolean>) => {
      state.appplyActionStatus = action.payload;
    },
    provideDocumentDetail: (
      state,
      action: PayloadAction<FileStringDetail | null>
    ) => {
      state.fileDocumentDetail = action.payload;
    },
  },
});

export const { appplyActionDocument, provideDocumentDetail } =
  FileDocumentPicker.actions;
export default FileDocumentPicker.reducer;
